import { render, staticRenderFns } from "./taskSidebar.vue?vue&type=template&id=2b5a6848&"
import script from "./taskSidebar.vue?vue&type=script&lang=js&"
export * from "./taskSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports